export default __webpack_public_path__ + "static/phng-meta-11aa0589510da87cdb4dd1bcd2e5d3fe.png";